import {
	useV2FTMigrationInitFlow as useSharedV2FTMigrationInitFlow,
	type UseV2FTMigrationInitFlowProps
} from '@capsicum/features/nc-wallet/shared';

import { useV2MigrationWhitelistedScreenChecker } from './useV2MigrationWhitelistedScreenChecker';

export const useV2FTMigrationInitFlow = ({ fallback, ...props }: UseV2FTMigrationInitFlowProps) => {
	const isWhitelistedScreen = useV2MigrationWhitelistedScreenChecker();
	const { name, screen } = useSharedV2FTMigrationInitFlow({ ...props, enabled: !isWhitelistedScreen });

	return (
		<>
			{(!screen || name === 'MODAL') && fallback}
			{screen}
		</>
	);
};
